import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a4cc436"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-center justify-center fill-height" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-h5 font-weight-bold" }, "Your password has been changed.", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-body-1" }, "Please log in to proceed.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_EmailPrompt = _resolveComponent("EmailPrompt")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_stepper_window_item = _resolveComponent("v-stepper-window-item")!
  const _component_ActivationPrompt = _resolveComponent("ActivationPrompt")!
  const _component_ResendPrompt = _resolveComponent("ResendPrompt")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_stepper_window = _resolveComponent("v-stepper-window")!
  const _component_v_stepper = _resolveComponent("v-stepper")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["fill-height overflow-x-hidden", _ctx.smAndDown ? 'background-mob' : 'background'])
  }, [
    _createVNode(_component_v_row, { style: {"height":"calc(100% - 48px)"} }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              class: "fill-height pa-4",
              justify: "center",
              align: "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "auto" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "background-border",
                      flat: "",
                      height: _ctx.activeStep === _ctx.ResetSteps.ActivationPrompt ? 620 : 500,
                      color: "background"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_title, { class: "d-flex justify-center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_img, {
                              src: _ctx.logoSrc,
                              "max-width": "300",
                              class: "mt-6"
                            }, {
                              placeholder: _withCtx(() => [
                                _createElementVNode("div", _hoisted_1, [
                                  _createVNode(_component_v_progress_circular, {
                                    color: "grey-lighten-4",
                                    indeterminate: ""
                                  })
                                ])
                              ]),
                              _: 1
                            }, 8, ["src"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_stepper, {
                          modelValue: _ctx.activeStep,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.activeStep) = $event)),
                          flat: "",
                          class: "fill-height",
                          id: "login-stepper",
                          width: "380"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_stepper_window, { "model-value": _ctx.activeStep }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_stepper_window_item, {
                                  value: _ctx.ResetSteps.EmailPrompt,
                                  class: "fill-height",
                                  "selected-class": "px-3"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      class: "fill-height",
                                      justify: "center",
                                      align: "center",
                                      "no-gutters": ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: "fill-height"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_EmailPrompt, {
                                              onCheckEmail: _cache[0] || (_cache[0] = ($event: any) => {_ctx.username = $event; _ctx.checkUser(_ctx.$route.query.username ? _ctx.$route.query.username : _ctx.username);}),
                                              "query-username": _ctx.$route.query.username ? _ctx.$route.query.username : _ctx.username,
                                              error: _ctx.error,
                                              onClearError: _cache[1] || (_cache[1] = ($event: any) => (_ctx.error = ''))
                                            }, null, 8, ["query-username", "error"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"]),
                                _createVNode(_component_v_stepper_window_item, {
                                  value: _ctx.ResetSteps.ActivationPrompt,
                                  class: "fill-height"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      class: "fill-height",
                                      justify: "center",
                                      align: "center",
                                      "no-gutters": ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ActivationPrompt, {
                                              info: _ctx.info,
                                              username: _ctx.$route.query.username ? _ctx.$route.query.username : _ctx.username,
                                              "query-code": _ctx.$route.query.code ? _ctx.$route.query.code : null,
                                              onSuccess: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeStep = _ctx.ResetSteps.Success)),
                                              onGoToResend: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeStep = _ctx.ResetSteps.Resend))
                                            }, null, 8, ["info", "username", "query-code"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"]),
                                _createVNode(_component_v_stepper_window_item, {
                                  value: _ctx.ResetSteps.Resend,
                                  class: "fill-height"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      class: "fill-height",
                                      justify: "center",
                                      align: "center",
                                      "no-gutters": ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: "px-4"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ResendPrompt, {
                                              onGoToEmail: _cache[4] || (_cache[4] = ($event: any) => (_ctx.activeStep = _ctx.ResetSteps.EmailPrompt)),
                                              username: _ctx.$route.query.username ? _ctx.$route.query.username : _ctx.username,
                                              activating: false
                                            }, null, 8, ["username"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"]),
                                _createVNode(_component_v_stepper_window_item, {
                                  value: _ctx.ResetSteps.Success,
                                  class: "fill-height"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      class: "fill-height",
                                      justify: "center",
                                      align: "center",
                                      "no-gutters": ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_row, {
                                              justify: "center",
                                              align: "center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, {
                                                  cols: "12",
                                                  class: "pa-4"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_card, {
                                                      variant: "flat",
                                                      class: "px-4 py-6"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_row, {
                                                          "no-gutters": "",
                                                          align: "center",
                                                          justify: "center"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_col, {
                                                              cols: "12",
                                                              class: "text-center"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _hoisted_2
                                                              ]),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_v_col, {
                                                              cols: "12",
                                                              class: "my-6 text-center"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _hoisted_3
                                                              ]),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_btn, {
                                                                  variant: "flat",
                                                                  width: "95",
                                                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push({name: 'login', query: {username: _ctx.username}}))),
                                                                  color: "primary"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode("Log in")
                                                                  ]),
                                                                  _: 1
                                                                })
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"])
                              ]),
                              _: 1
                            }, 8, ["model-value"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["height"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 2))
}